// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2Udw0","dragIcon":"Choice_dragIcon__1uiR_","left":"Choice_left__3tUJE","input":"Choice_input__1n4LL"};